import React, {} from 'react';
const styles = {"social-btn":"SocialSignInButton-module__social-btn__uFD-Y","glyph":"SocialSignInButton-module__glyph__XmD2F","label":"SocialSignInButton-module__label__9TVQH"};
/**
 * Renders as a real `<a href>`, not a button with a click handler — a provider sign-in link
 * must keep working before hydration and support right-click/middle-click/"open in new tab",
 * exactly like the legacy page's plain anchor (spec FR-008: no auth behavior change).
 */
export function SocialSignInButton({ label, href, children }) {
    return (React.createElement("a", { href: href, className: styles['social-btn'] },
        React.createElement("span", { className: styles.glyph, "aria-hidden": "true" }, children),
        React.createElement("span", { className: styles.label }, label)));
}
//# sourceMappingURL=SocialSignInButton.js.map